<template>
  <div class="shows">
    <h1><span class="resize" style="cursor:pointer" @click="back">&lt;&nbsp;</span>{{name}}</h1>
    <div class="data">
      <div v-for="season in seasons" :key="season.name" class="panel show" @click="open(season)">
        {{season.name}}
      </div>
    </div>
  </div>
</template>

<script>

import config from '../config';

export default {
  name: 'Seasons',
  data() {
    return {
      seasons: [],
      name: this.$route.params.name
    }
  },
  methods: {
    open(season) {
      this.$router.push(`/episodes/${this.name}/${season.name}`)
    },
    back() {
      this.$router.push('/shows')
    },
    getSeasons() {
      const password = localStorage.getItem('password');
      const authorization = localStorage.getItem('authorization');

      this.axios.get(`${config.api}/seasons/${this.$route.params.name}`, {
        headers: {
          password,
          authorization
        }
      })
      .then(result => {
        this.seasons = result.data;
      })
    }
  },
  created() {
    this.getSeasons();
  }
}
</script>

<style scoped>

.show {
  width: 100px;
  height: 100px;

  transition: 200ms;

  transform: scale(1);

  cursor: pointer;

  margin: 5px;
}

.show:hover {
  transform: scale(1.1);
}

.data {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Seasons.vue